import { z } from 'zod';
import { BuyerRoleSchema, ContactSchema, ContactCreationSourceSchema, ContactClientAssociationSchema } from './client.js';
import { AttendeeResearchSchema } from './meetings-page.js';
import { SortDirectionSchema } from './pagination.js';
import { CrmProvider } from './crm.js';
export const ContactClientRefSchema = z.object({
    id: z.string().uuid(),
    name: z.string(),
    logoUrl: z.string().url().nullable().optional(),
});
export const OrgContactListItemSchema = z.object({
    id: z.string().uuid(),
    name: z.string().min(1).max(255),
    title: z.string().max(255).nullable().optional(),
    email: z.string().email().max(255).nullable().optional(),
    phone: z.string().max(50).nullable().optional(),
    linkedinUrl: z.string().url().max(500).nullable().optional(),
    clients: z.array(ContactClientRefSchema),
    dealRoles: z.array(BuyerRoleSchema),
    source: ContactCreationSourceSchema,
    sourceProvider: z.enum(Object.values(CrmProvider)).nullable().optional(),
    createdByUserId: z.string().uuid().nullable().optional(),
    createdByUserName: z.string().max(255).nullable().optional(),
    createdByUserAvatarUrl: z.string().url().nullable().optional(),
    ownerUserId: z.string().uuid().nullable().optional(),
    lastActivityAt: z.string().datetime().nullable().optional(),
    createdAt: z.string().datetime(),
    deletedAt: z.string().datetime().nullable().optional(),
    customFields: z.record(z.string(), z.unknown()).optional(),
});
export const OrgContactDealSchema = z.object({
    id: z.string().uuid(),
    clientId: z.string().uuid(),
    name: z.string(),
    stage: z.string().nullable().optional(),
    roles: z.array(BuyerRoleSchema),
    clientName: z.string().nullable().optional(),
});
export const OrgContactDetailSchema = OrgContactListItemSchema.extend({
    associations: z.array(ContactClientAssociationSchema),
    deals: z.array(OrgContactDealSchema),
    researchData: AttendeeResearchSchema.nullable().optional(),
    customFields: z.record(z.string(), z.unknown()).optional(),
});
export const ListContactsQuerySchema = z.object({
    deletedOnly: z.boolean().optional(),
    clientId: z.string().uuid().optional(),
    dealId: z.string().uuid().optional(),
    buyerRole: BuyerRoleSchema.optional(),
    search: z.string().optional(),
    page: z.number().int().positive().optional(),
    pageSize: z.number().int().positive().max(100).optional(),
    sortBy: z.enum(['name', 'email', 'lastActivityAt', 'createdAt']).optional(),
    sortDir: SortDirectionSchema.optional(),
});
export const DeletedContactsResponseSchema = z.object({
    contacts: z.array(ContactSchema),
    total: z.number().int().min(0),
});
export const ContactsResponseSchema = z.object({
    contacts: z.array(OrgContactListItemSchema),
    items: z.array(OrgContactListItemSchema),
    total: z.number().int().min(0),
    page: z.number().int().positive(),
    pageSize: z.number().int().positive(),
    totalPages: z.number().int().nonnegative(),
    hasNextPage: z.boolean(),
    hasPreviousPage: z.boolean(),
});
export const ContactFileSourceType = {
    EMAIL: 'email',
    MEETING: 'meeting',
    MANUAL: 'manual',
};
export const ContactFileSort = {
    DATE_DESC: 'date_desc',
    DATE_ASC: 'date_asc',
    NAME_ASC: 'name_asc',
    NAME_DESC: 'name_desc',
    SIZE_DESC: 'size_desc',
    SIZE_ASC: 'size_asc',
};
